import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
  Divider
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import RequestDetailCard from "./RequestDetailCard.jsx";

function ShiftChangeDialog({
  open,
  onClose,
  onConfirm,
  requestType,
  rowData,
  t
}) {
  // Configurazione in base al tipo (stessa di prima)
  const getConfig = () => {
    switch(requestType) {
      case "Delete":
        return {
          title: t("Elimina richiesta"),
          icon: <DeleteIcon sx={{ color: "#d32f2f", fontSize: 28 }} />,
          color: "#d32f2f",
          actionLabel: t("Elimina"),
          confirmText: t("Conferma eliminazione"),
          warningText: t("Stai per eliminare la tua richiesta di cambio turno. Questa operazione è irreversibile.")
        };
      case "Yes":
        return {
          title: t("Approva richiesta"),
          icon: <CheckCircleIcon sx={{ color: "#2e7d32", fontSize: 28 }} />,
          color: "#2e7d32",
          actionLabel: t("Approva"),
          confirmText: t("Conferma approvazione"),
          warningText: t("Stai per approvare questa richiesta di cambio turno.")
        };
      case "No":
        return {
          title: t("Rifiuta richiesta"),
          icon: <CancelIcon sx={{ color: "#d32f2f", fontSize: 28 }} />,
          color: "#d32f2f",
          actionLabel: t("Rifiuta"),
          confirmText: t("Conferma rifiuto"),
          warningText: t("Stai per rifiutare questa richiesta di cambio turno.")
        };
      default:
        return {
          title: t("Conferma"),
          icon: <WarningIcon sx={{ color: "#ed6c02", fontSize: 28 }} />,
          color: "#ed6c02",
          actionLabel: t("Conferma"),
          confirmText: t("Conferma operazione"),
          warningText: t("Sei sicuro di voler procedere?")
        };
    }
  };

  const config = getConfig();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {/* HEADER - Stile coerente con ShiftRequestsDialog */}
      <DialogTitle sx={{
        bgcolor: "primary.main",
        color: "white",
        display: "flex",
        alignItems: "center",
        gap: 1,
        py: 1.5
      }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
          {config.icon}
          <Typography variant="h6" sx={{ color: "white", fontWeight: "bold" }}>
            {config.title}
          </Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* CONTENUTO - Layout coerente */}
      <DialogContent sx={{ pt: "16px !important" }}>
        {/* Dettagli richiesta - USA LO STESSO COMPONENTE */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1.5, fontWeight: "bold" }}>
            {t("DETTAGLI RICHIESTA")}
          </Typography>
          <RequestDetailCard
            fromDescription={rowData?.fromDescription || "-"}
            toDescription={rowData?.toDescription || "-"}
            confirmedAt={rowData?.confirmedAt}
            refusedAt={rowData?.refusedAt}
            t={t}
          />
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Messaggio di conferma */}
        <Box sx={{ 
          bgcolor: `${config.color}08`,
          p: 2,
          borderRadius: 2,
          border: `1px solid ${config.color}25`
        }}>
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
            <WarningIcon sx={{ color: config.color, fontSize: 20, mt: 0.5 }} />
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: config.color }}>
                {config.confirmText}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {config.warningText}
              </Typography>
            </Box>
          </Box>
        </Box>
      </DialogContent>

      {/* FOOTER */}
      <DialogActions sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}>
        <Button onClick={onClose} color="inherit">
          {t("Annulla")}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            bgcolor: config.color,
            "&:hover": { bgcolor: config.color, opacity: 0.85 }
          }}
        >
          {config.actionLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default React.memo(ShiftChangeDialog);